import { HttpClient } from "@angular/common/http";
import { LacrosseEntity } from "./lacrosse.entity";
import { FirebaseAuthService } from "../noizu/services/firebase-auth.service";

export class DataBatchesEntity extends LacrosseEntity {
  public notes: String = "";
  public name: String;
  public new: boolean = false;

  constructor(client: HttpClient, auth: FirebaseAuthService, json) {
    super(client, auth, json);
    this._kind = "batches";
    this._singular = "batch";
    this.name = json.name;
    this.notes = json.notes;
    if (json.new) {
      this.new = json.new;
    }
  }

  refresh(data) {
    this.identifier = data.id;
    this.name = data.name;
    this.new = false;
    return super.refresh(data);
  }

  BatchesUpdate() {
      if (this.new) {
        let entity = this.toJson({for: "appengine"});
        entity.id = entity.identifier;
        return this._post(
          `${this.apiBase()}/${this._kind}`,
          entity,
          (data, resolve) => {resolve(this.refresh(data));},
          {}
        );
      } else {
        return this._put(
          `${this.apiBase()}/${this._singular}/${this.identifier}`,
          this.toJson({for: "appengine"}),
          (data, resolve) => {resolve(this.refresh(data));},
          {}
        );
      }
  }

} 
